// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"657":"3a8ae697","787":"c83c0d3e"}[chunkId] + ".chunk.js";
};